import React from 'react';
// @mui
import MultipleUploadComponent from '../../components/upload/MultipleUploadComponent';
import SingleUploadComponent from '../../components/upload/SingleUploadComponent';
import UploadLayout from '../../components/upload/UploadLayout';
import FileUploadService from '../../services/FileUploadService';
import { getFileCategoryType, getFileTypes } from '../../config/fileConfig';
import { Typography } from '@mui/material';
import i18n from '../../i18';
import PreviewModal from '../../components/image-preview/PreviewModal';

export default class DialogUploadField extends React.Component {
    // required fields on head for upload
    //uploadType: single or multiple(if not multiple), fileType: merchant or coin,
    //fileTypeId: (ex. merchantFileType, id of field fileType, fileParent: 'merchantId' },
    constructor(props) {
        super(props);
        this.state = {
            open: false,
            files: [],
            itemId: '',
            errorMessage: '',
            openPreview: false
        };
        this.fileService = new FileUploadService(
            this.props.context.getState().server
        );
        this.fieldFileType = getFileCategoryType(this.props.field.id);
        this.fileTypes = getFileTypes(this.props.field.id);
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (prevProps.value !== this.props.value) {
            if (this.props.value === undefined) {
                this.setState({ files: [] });
            }
            if (this.state.files.length === 0) {
                this.initializeFiles(this.props.value);
            }
        }
    }

    initializeFiles = async (dialogValues) => {
        const context = this.props.context;
        const values = Array.isArray(dialogValues)
            ? dialogValues
            : dialogValues
                ? [dialogValues]
                : [];
        if (!values.length) return;

        for (const value of values) {
            this.setState((prevState) => ({
                files: [
                    ...prevState.files,
                    {
                        id: value.id,
                        name: value.name,
                        url: context.getState().images[value.name],
                        [this.fieldFileType]:
                            value[this.fieldFileType] || this.fileTypes[0]
                    }
                ]
            }));
        }
    };

    handleFileUpload = async (event, fileParentId, fileType) => {
        if (!event.target.files || !event.target.files.length) return;

        const file = event.target.files[0];
        try {
            const uploadResult = await this.fileService.uploadFile(
                file,
                fileType,
                fileParentId
            );
            const uploadedFile = await this.fileService.getFile(
                uploadResult.name,
                uploadResult.id,
                [this.fieldFileType],
                uploadResult[this.fieldFileType] || this.fileTypes[0]
            );
            this.setState(
                (prevState) => ({
                    files: [...prevState.files, uploadedFile]
                }),
                () => {
                    this.props.onChange(this.props.field.id, this.state.files);
                }
            );
        } catch (error) {
            this.setState({ errorMessage: error.toString() });
        }
    };

    handleDeleteFile() {
        const id = this.state.itemId;
        if (this.props.field.uploadType === 'single') {
            this.props.onChange(this.props.field.id, '');
            this.setState({ files: [], itemId: '' });
        } else {
            this.props.onChange(
                this.props.field.id,
                this.state.files.filter((value) => value.id !== id)
            );
            this.setState({
                files: this.state.files.filter((file) => file.id !== id),
                itemId: ''
            });
        }
    }

    handleInputFileType(event, id) {
        const newFiles = this.state.files.map((file) => {
            if (file.id === id) {
                return { ...file, [this.fieldFileType]: event.target.value };
            }
            return file;
        });
        this.setState({ files: newFiles });
        this.props.onChange(this.props.field.id, newFiles);
    }
    handleOpenPopover(event, id) {
        this.setState({ open: event.currentTarget, itemId: id });
    }
    handleClose() {
        this.setState({ open: null });
    }

    handleOpenPreview() {
        this.setState({ openPreview: true, open: null });
    }

    renderPreviewModal() {
        const imageId = this.state.itemId;
        const image = this.state.files.find((file) => file.id === imageId);
        if (!image) return null;
        return (
            <PreviewModal
                open={this.state.openPreview}
                onClose={() => this.setState({ openPreview: false })}
                imageUrl={image.url}
                altText={image.name || 'Image'}
            />
        );
    }

    render() {
        const fileParentId = this.props.data[this.props.field.fileParent];
        const fileType = this.props.field.fileType || 'merchant';

        const translatedLabel = i18n.t(
            `columns.${this.props.field.label}Upload`
        );
        const required = this.props.field.required;
        const requiredLabel = required ? ' *' : '';

        return (
            <>
                <Typography variant="subtitle2">
                    {translatedLabel + requiredLabel}
                </Typography>
                <UploadLayout
                    open={this.state.open}
                    item={this.state.itemId}
                    onClose={() => this.handleClose()}
                    error={this.state.errorMessage}
                    label={this.props.field.label}
                    handleDeleteFile={() => this.handleDeleteFile()}
                    handlePreview={() => this.handleOpenPreview()}
                >
                    {this.props.field.uploadType === 'single' ? (
                        <SingleUploadComponent
                            file={this.state.files[0]}
                            inputFileType={
                                !this.props.field.disableInputFileType
                            }
                            fileTypes={this.fileTypes}
                            fieldFileType={this.fieldFileType}
                            handleFileUpload={(event) =>
                                this.handleFileUpload(
                                    event,
                                    fileParentId,
                                    fileType
                                )
                            }
                            handleInput={(event, id) =>
                                this.handleInputFileType(event, id)
                            }
                            onOpenPopover={(event, id) =>
                                this.handleOpenPopover(event, id)
                            }
                        />
                    ) : (
                        <MultipleUploadComponent
                            files={this.state.files}
                            handleFileUpload={(event) =>
                                this.handleFileUpload(
                                    event,
                                    fileParentId,
                                    fileType
                                )
                            }
                            fieldFileType={this.fieldFileType}
                            onOpenPopover={(event, id) =>
                                this.handleOpenPopover(event, id)
                            }
                            inputFileType={
                                !this.props.field.disableInputFileType
                            }
                            fileTypes={this.fileTypes}
                            handleInput={(event, id) =>
                                this.handleInputFileType(event, id)
                            }
                        />
                    )}
                </UploadLayout>
                {this.renderPreviewModal()}
            </>
        );
    }
}
